<ng-container [formGroup]="form">
    <!-- ngClass added as css need to be changed in case of date range picker -->
    <div [ngClass]="getDivClass(question)" id="{{question.key}}_ques"
        *ngIf="(question.controlType !== 'label' && question.visible) || (question.controlType == 'label' && question.visible && (question.value !== undefined || question.view_required))">
        @if(question.controlType !== 'hidden' &&
            question.controlType !== 'checkbox' &&question.controlType !== 'composite-array' && !insideGrid &&question.label != null &&
            !(question.controlType === 'radio' && question.label.trim() === ''))
            {
        <ng-container>
            <label id="{{question.key}}_check" [attr.for]="question.key" [ngClass]="!question.required ? '': 'required'"
                [innerHTML]="question.label | translate | async">
                <!-- <b> {{question.label | translate | async}}</b> -->
                <!-- {{question.key}} -->
            </label>
            <!-- <sup [ngClass]="{'not-visible': !question.required}" class="req">*</sup> -->
        </ng-container>
    }
        <!-- remove class ([ngClass]="!question.required ? '': 'required'") for extra asterisk -->
        <label *ngIf="question.controlType == 'checkbox' && !question.is_label_required && !insideGrid">
        </label>
        @if(question.controlType == 'checkbox' && question.is_label_required && question.options != undefined && !insideGrid)
        {
        <div>
            <label id="{{question.key}}_check" [attr.for]="question.key" [ngClass]="!question.required ? '': 'required'"
                [innerHTML]="question.label | translate | async">
            </label>
        </div>
    }
        <ng-container [ngSwitch]="question.controlType">
            <ng-container *ngSwitchCase="'label'">
                @if(question.type == 'String')
                {
                <span class="form-control-plaintext">{{ question.value }} </span>
                }
                @if(question.type == 'datetime')
                {
                <span class="form-control-plaintext">{{ question.value |
                    dateTimeFormat }} </span>
                }
                @if(question.type == 'date')
                {
                <span class="form-control-plaintext">
                    {{ question.value | dateFormat }} </span>
                }
                @if(question.type == 'time')
                {
                <span class="form-control-plaintext">
                    {{ question.value | timeFormat }} </span>
                }
            </ng-container>
            <!--textbox-->
            <ng-container *ngSwitchCase="'textbox'">
                @if(question.asideButton !=undefined && question.asideButton.expression!=undefined && checkExpression(question.asideButton.expression))
                {
                <div (click)="emitButtonTo()" style="height: 20px; width: 20px;">
                    <img [src]="question.asideButton.src" style="height: 20px; width: 20px;">
                </div>
            }
            @if(question.type == 'date')
            {
                <input [formControlName]="question.key"
                    [attr.disabled]="question.disabled ? '' : null" [id]="question.key"
                    [placeholder]="question.placeholder | translate | async" value="question.value" class="form-control"
                    [maxlength]="question.maxlength" date-formatter [pattern]="question.pattern"
                    [minlength]="question.minlength"
                    (keyup)="setManualChange(question,true);valueChange($event,question)">
            }
            @if(question.type != 'date')
            {
                <input [formControlName]="question.key"
                    [attr.disabled]="question.disabled ? '' : null" [id]="question.key+(index==0?'':index)"
                    [placeholder]="question.placeholder | translate | async" value="question.value" class="form-control" [ngClass]="{ 'is-invalid': !isValid && f[question.key].errors }"
                    [maxlength]="question.maxlength" [pattern]="rolePermissionService.checkdecimalConfig() && question.type=='decimal_currency'?preferenceService.currencyPattern():question.pattern" [minlength]="question.minlength"
                    (change)="trimValue(question);setManualChange(question,true);valueChange($event,question)"
                    (input)="question.macro_datasource ? macroChangeEvent($event.target.value): ''">
            }
                <span *ngIf="showFlag" class="input-error-msg">{{question.label | translate | async}} Already
                    Exist</span>
                    @if(question.text_buttonIcon !=undefined && question.type !='date')
                    {
                    <span class="form-inline-button" [id]="question.key+'_button'" (click)="emitButtonTo();">
                        <i *ngIf="question.text_buttonIcon" [ngClass]="question.text_buttonIcon?question.text_buttonIcon:''"></i>
                    </span>
                }
            </ng-container>
            <ng-container *ngSwitchCase="'textbox'">
                @if(preferenceService.checkCommonConfigEnabled('voice_search') && question.type !='date' && !question.disabled)
                {
                <span class="advsearchspan-mic" [id]="question.key+'speech'" (click)="textToSpeech(question.key+(index==0?'':index),question.disabled,question.key);">
                    <i aria-hidden="true" class="fa fa-microphone"></i>
                </span>
            }
            </ng-container>
            <!-- countrymobno -->
            <ng-container *ngSwitchCase="'countrymobno'">
                <dhs-intl-tel-input [formControlName]="question.key" [question]="question"
                (change)="setManualChange(question,true);valueChange($event,question)" [value]="question.value" >
                </dhs-intl-tel-input>
            </ng-container>
            <!-- button -->
            <ng-container *ngSwitchCase="'button'">
                @if(question.permission_check ? rolePermissionService.checkAccessPermission(question.permission_check['action_name'], question.permission_check['resource'], question.permission_check['application'])  : true)
                {
                <button type="button" id="{{question.id}}" [attr.disabled]="question.disabled ? '' : null"
                    class="{{question.class}}"
                    (click)="question['buttonClicked']=true;setManualChange(question,true);valueChange($event,question)"
                    (click)="question.emitOnSave ? emitDataOnCustomButton():''">{{question.name | translate | async}}
                    <i *ngIf="question.buttonIcon" [ngClass]="question.buttonIcon?question.buttonIcon:''"></i>
                </button>
            }
            </ng-container>
            <ng-container *ngSwitchCase="'range-slider'">
                @if(question.visible)
                {
                <app-range-slider [formControlName]="question.key" [question]="question"
                    (valueChange)="setManualChange(question,true);valueChange($event,question)"
                    [value]="question.value"></app-range-slider>
                }
            </ng-container>
            <ng-container *ngSwitchCase="'subHeading'">
                <div class="block-sub-heading">{{ question.value }} </div>
            </ng-container>
            <!--DropDown-->
            <ng-container *ngSwitchCase="'dropdown'">
                <!-- {{getQuestion(question)}} -->

                <!-- <ng-container [attr.class]="question.resource_add? 'selectdiv' : ''"> -->
                <select (change)="setManualChange(question,true);valueChangeDd($event,question)"
                    [formControlName]="question.key" [ngClass]="{ 'is-invalid': !isValid && f[question.key].errors }"
                    [id]="question.key" class="form-control" [attr.disabled]="question.disabled ? '' : null">
@if(!question.removeSelect)
{
                    <option value="">{{'field.label.select' | translate | async }}
                    </option>
                }
                    @if(!question.class_conditions)
                    {
                    <ng-container>
                        @for (option of (question.options | sortData : question); track trackById(option) ?? $index) {
                        <option
                            [ngValue]="getOptionsValue(option, question)">
                            {{ getOptionsKey(option, question) }}
                        </option>
                    }
                        @if(question.showMore!=undefined && question.showMore)
                    {
                        <option value="paginate">--show More--
                        </option>
                    }
                    </ng-container>
                }
                    @if(question.class_conditions)
                    {
                    <ng-container>
                        @for (option of (question.options | sortData: question); track trackById(option) ?? $index) {
                        <option
                            [ngValue]="getOptionsValue(option, question)"
                            [ngClass]="option | getClass:question.class_conditions">
                            {{ getOptionsKey(option, question) }}
                        </option>
                    }
                        @if(question.showMore!=undefined && question.showMore)
                        {
                        <option value="paginate">--show More--
                        </option>
                    }
                    </ng-container>
                    }
                </select>
                <!-- </div> -->
                 @if(question.resource_add)
                 {
                <div class="btndiv">
                    &nbsp;
                    <button type="button" class="primary-btn mr-1" (click)="openDropDownObjectPopup(question)">
                        <i class="fa fa-plus" aria-hidden="true"></i>
                    </button>
                </div>
            }
                <!-- </ng-container> -->
            </ng-container>
            <!--google recaptcha-->
            <ng-container *ngSwitchCase="'recaptcha'">
                <re-captcha [formControlName]="question.key" siteKey="{{recaptchaKey}}" required>
                </re-captcha>
            </ng-container>
            <!--signature pad-->
            <ng-container *ngSwitchCase="'signature'">
                <signature [formControlName]="question.key" [question]="question"
                    (change)="setManualChange(question,true);valueChange($event,question)" [value]="question.value">
                </signature>
            </ng-container>
            <!--video path-->
             <ng-container *ngSwitchCase="'kx-video'">
                <app-video-player [formControlName]="question.key" [question]="question" [value]="question.value">
                </app-video-player>
            </ng-container>
            <!-- Text Entry for Assessment Template -->
            <ng-container *ngSwitchCase="'text-entry-question'">
                <textentry-question [formControlName]="question.key" [question]="question" [pattern]="question.pattern" [maxlength]="question.maxlength" [minlength]="question.minlength" [disabled_]="question.disabled" (change)="valueChange($event,question)" [value]="question.value">
                </textentry-question>
            </ng-container>

             <!-- Single Choice for Assessment Template -->
            <ng-container *ngSwitchCase="'single-choice-question'">
                <single-choice-question [formControlName]="question.key" [question]="question" [pattern]="question.pattern" [maxlength]="question.maxlength" [minlength]="question.minlength" [disabled_]="question.disabled" (change)="valueChange($event,question)" [value]="question.value">
                </single-choice-question>
            </ng-container>

            <!--radio-->
            <ng-container *ngSwitchCase="'radio'">
             @for (option of question.options; track option.id) {
                <div class="radio-container">
                    <label [ngClass]="question.disabled ? 'radio-wrapper _radio-disabled':'radio-wrapper'">{{
                        option[question.getterValue!=undefined && question.getterValue?question.getterValue:'value'] |
                        translate | async }}
                        <input type="radio" [formControlName]="question.key"
                            [ngClass]="{ 'is-invalid': !isValid && f[question.key].errors }"
                            [value]="option[question.getterKey!=undefined && question.getterKey?question.getterKey:'id']"
                            [attr.disabled]="question.disabled ? '' : null"
                            [id]="option[question.getterKey!=undefined && question.getterKey?question.getterKey:'id']"
                            (change)="setManualChange(question,true);valueChange($event,question)">
                        <span class="check-mark-radio"></span>
                    </label>
                </div>
            }
            </ng-container>
            <!-- multiple-slot -->
            <!-- <ng-container *ngSwitchCase="'multiple-slot'">
                <dhs-button-table id="checkbox" [disabled_]="question.disabled" [question]="question"
                    [options]="question.options"
                    (valueChange)="setManualChange(question,true);valueChange($event,question)"></dhs-button-table>
            </ng-container> -->
            <!--multi-dropdown-->
            <dhs-multi-dropdown *ngSwitchCase="'multi-dropdown'" [formControlName]="question.key" [id]="question.key"
                [options]="question.options" [question]="question" [config]="question.config">
            </dhs-multi-dropdown>
            <!--checkbox-->
            <dhs-checkbox id="checkbox" [disabled_]="question.disabled"
                [ngClass]="{ 'is-invalid': !isValid && f[question.key].errors,'disabled': question.disabled}"
                *ngSwitchCase="'checkbox'" [type]="question.type" [required]="question.required"
                [formControlName]="question.key" [id]="question.key" [innerHtml]='question.htmlText'
                [label]="question.text" [options]="question.options"
                (valueChange)="setManualChange(question,true);valueChange($event,question)"
                [is_rich_text]="question.is_rich_text" [is_label_required]="question.is_label_required"
                [showLabel]="!insideGrid" [question]="question">
            </dhs-checkbox>

            <!--textarea-->
            <textarea *ngSwitchCase="'textarea'" [ngClass]="{ 'is-invalid': !isValid && f[question.key].errors }"
                [placeholder]="question.placeholder | translate | async" [formControlName]="question.key"
                [id]="question.key+(index==0?'':index)"
                (change)="trimValue(question);setManualChange(question,true);valueChange($event,question)"
                [pattern]="question.pattern" class="form-control" [attr.rows]="question.rows?question.rows:2"
                [maxlength]="question.maxlength" [minlength]="question.minlength"
                [attr.disabled]="question.disabled ? '' : null"
                (input)="question.macro_datasource ? macroChangeEvent($event.target.value): ''" appTextareaResize>
        </textarea>
            <ng-container *ngSwitchCase="'textarea'">
                @if(preferenceService.checkCommonConfigEnabled('voice_search') && !question.disabled)
                {
                <span class="advsearchspan-mic textarea-mic" [id]="question.key+'speech'" (click)="textToSpeech(question.key+(index==0?'':index),question.disabled,question.key);">
                    <i aria-hidden="true" class="fa fa-microphone"></i>
                </span>
            }
            </ng-container>
            <!--numberbox-->
            <ng-template #popTemplateToolTip>
                {{this.tooltip_value}}
            </ng-template>
            <!-- {{question|json}} -->
            <input *ngSwitchCase="'numberbox'" (paste)="onPaste($event)"
                [pattern]="rolePermissionService.checkdecimalConfig() && question.type=='decimal_currency'?preferenceService.currencyPattern():question.pattern"
                [placeholder]="question.placeholder | translate | async" [formControlName]="question.key" [value]="question.value"
                [id]="question.key+(index==0?'':index)" type="number" class="form-control" [min]="question.min" [max]="question.max"
                [fieldType]="rolePermissionService.checkdecimalConfig() && question.type=='decimal_currency'?'Double':question.fieldType" (change)="setManualChange(question,true);valueChange($event,question)"
                [ngClass]="{ 'is-invalid': !isValid && f[question.key].errors }" [attr.step]="question.step"
                [attr.disabled]="question.disabled ? '' : null" (keyup)="onKeyupNumberEvent($event, question)" scrollOverlay
                [popover]="getToolTip(question)?popTemplateToolTip:null" container="body" placement="top"
                containerClass="info-popover number-box-popover">
            <ng-container *ngSwitchCase="'numberbox'">
                @if(preferenceService.checkCommonConfigEnabled('voice_search') && !question.disabled)
                {
                <span class="advsearchspan-mic" [id]="question.key+'speech'" (click)="textToSpeech(question.key+(index==0?'':index),question.disabled,question.key);">
                    <i aria-hidden="true" class="fa fa-microphone"></i>
                </span>
            }
            </ng-container>
            <!--hidden-->
            <input *ngSwitchCase="'hidden'" [formControlName]="question.key" [value]="question.value"
                [id]="question.key" type="hidden" (change)="setManualChange(question,true);valueChange($event,question)"
                class="form-control">
            <!--datepicker-->
            <dhs-datetimepicker *ngSwitchCase="'datetimepicker'"
                [ngClass]="{ 'is-invalid': !isValid && f[question.key].errors }" [formControlName]="question.key"
                [id]="question.key" [format]="question.format" [icon]="question.icon">
            </dhs-datetimepicker>
            <!--html-editor-->
            <ng-container *ngSwitchCase="'html-editor'">
                <ckeditor [id]="question.key+(index==0?'':index)" [formControlName]="question.key" [config]="ckeConfig"
                    (change)="setManualChange(question,true);valueChange($event,question)">
                </ckeditor>
            </ng-container>
            <ng-container *ngSwitchCase="'html-editor'">
                @if(preferenceService.checkCommonConfigEnabled('voice_search') && !question.disabled)
                {
                <span class="advsearchspan-mic" [id]="question.key+'speech'" (click)="textToSpeech(question.key+(index==0?'':index),question.disabled,question.key,true);">
                    <i aria-hidden="true" class="fa fa-microphone"></i>
                </span>
            }
            </ng-container>
            <!-- [config]="{ toolbar: [ 'heading', '|', 'bold', 'italic' ] }" [config]="ckeConfig" -->
            <!-- password -->
            <ng-container *ngSwitchCase="'password'">
                <div class="form-group input-group">
                    <input type="{{eye != 'fa-eye'?'text':'password'}}" [id]="question.key"
                        [formControlName]="question.key" [placeholder]="question.placeholder | translate | async"
                        [ngClass]="{ 'is-invalid': submitted && f.password.errors }" required
                        [minlength]="question.minlength"  [pattern]="question.pattern"
                        (keyup)="question.changeEvent?changeEvent($event,question.key):''"
                        [maxlength]="question.maxlength" class="form-control kx-input-default" placeholder="Password"
                        (change)="setManualChange(question,true);valueChange($event,question)" />
                    <div class="input-group-append">
                        <ng-template #showError>
                            <div>
                                @if(question.pattern)
                                {
                                <div>
                                    Password should have atleast a digit, upper and lower case characters, special character and should have length of 8 to 16 characters.
                                </div>
                            }
                            @if(!question.pattern)
                            {
                                <div>
                                    Password length should be between 8 - 16</div>
                                }
                            </div>
                        </ng-template>
                        @if(question.password_hint)
                        {
                        <div triggers="mouseenter:mouseleave" [popover]="showError" class="info-icons-pass">
                            <i class="fa fa-info-circle"></i>
                        </div>
                    }
                        <div class="input-group-text kx-search-btn-icon">
                            <span (click)="eye=(eye == 'fa-eye' ? 'fa-eye-slash':'fa-eye')">
                                <i class="fa {{eye}}"></i>
                            </span>
                        </div>
                    </div>
                </div>
            </ng-container>
            <!-- "pullable" -->
            <ng-container *ngSwitchCase="'pullable'">
                <dhs-pullable [formControlName]="question.key" [current_action]="action" [bannerJson]="question.bannerJson" [question]="question"
                    (valueChange)="setManualChange(question,true);valueChange($event,question)" style="width: 100%;">
                </dhs-pullable>
            </ng-container>
            <!-- "pushable" -->
            <ng-container *ngSwitchCase="'pushable'">
                <dhs-pushable [formControlName]="question.key" [bannerJson]="question.bannerJson" [question]="question"
                    (valueChange)="setManualChange(question,true);valueChange($event,question)" style="width: 100%;">
                </dhs-pushable>
            </ng-container>
            <!-- composite array -->
            <ng-container *ngSwitchCase="'composite-array'">
                <dhs-composite-array [current_action]="action" [formControlName]="question.key" [id]="question.key"
                    [minWidth]="question.minWidth" [resource]="question.resource" [arrayLimit]="question.arrayLimit"
                    [decorator]="decorator" [buttonText]="question.buttonText" [buttonProps]="question.buttonProps"
                    [bannerJson]="question.bannerJson" [parentForm]="form" [dependentField]="question.dependentField"
                    [dependentFieldMap]="question.dependentFieldMap"
                    [populateField]="question.populateField" (valueAdded)="eventFired($event,question);"
                    [value]="question.value" [replace_items]="question.replace_items" [item_key]="question.item_key"
                    [config]="config" [question]="question" (getData)="getDataFn($event)">
                </dhs-composite-array>
                @if(!isValid && f[question.key].errors)
                {
                <span class="text-danger">{{'formArrayErrorMsg' |
                    translate | async}}</span>
                }
            </ng-container>
            <!-- custom component -->
            <ng-container #customComponent>
            </ng-container>
            <!-----------------------Gird inside a form -------Start------->
            <ng-container *ngSwitchCase="'formwithgrid'">
                <kx-form-with-grid [formControlName]="question.key" [controlName]="form"
                    [dataResource]="question.dataResource" [data]="question.data" [value]="question.value"
                    [pagination]="question.pagination">
                </kx-form-with-grid>
            </ng-container>
            <!-----------------------Gird inside a form-------End------->
            <!-----------------------Search and Select box-------Start------->
            <ng-container *ngSwitchCase="'searchselect'">
                <div tabindex="0" (keyup)="handleSearchSelect($event)" class="searchselect-input" [ngClass]="question.add_fav ? 'fav-add-template': ''">
                    <kx-multiselect-dropdown tabindex="-1" [questions]="question" [config]="config"
                        [setId]="question.key" [settings]="question.defaultsetting" name="item"
                        [ngClass]="{ 'is-invalid': !isValid && f[question.key].errors }" [controlName]="form"
                        [placeholder]="question.placeholder | translate | async" [value]="question.value"
                        [format]="question.format" [data]="question.datasource" [formControlName]="question.key"
                        (createComponentEvent)="appendFieldsToForm($event)" [disabled]="question.disabled"
                        (onDropDownClose)="onDropDownClose()" (onSelect)="onItemSelect($event)"
                        (onDeSelect)="onItemDeSelect($event)" (onSelectAll)="onSelectAll($event)"
                        (onDeSelectAll)="onDeSelectAll($event)">
                    </kx-multiselect-dropdown>
                    @if(question.add_fav && formService['config'].template_selection)
                    {
                    <div class="img_fav" (click)="addToFav(question)">
                        @if(config.add_fav == undefined || !config.add_fav)
                        {
                        <img class="fav-icon" src="assets/images/emr/fav-template.svg"/>
                        }
                        @if(config.add_fav == true)
                        {
                        <img class="fav-icon" src="assets/images/emr/fav-template-filled.svg"/>
                        }
                    </div>
                }
                </div>
            </ng-container>

            <!-----------------------Fingerprint component-------------->
            <ng-container *ngSwitchCase="'fingerprint'">
                <app-fingerprint [value]="question.value" [formControlName]="question.key" [question] = "question" [id]="question.key"
                    (valueChange)="valueChange($event,question)">
                </app-fingerprint>
            </ng-container>
            <!-----------------------Search and Select box-------End------->

            <dhs-file-uploader *ngSwitchCase="'fileuploader'" [formControlName]="question.key" [id]="question.key"
                [multiple]="question.multiple" [config]="question.config" [formatsAllowed]="question.formatsAllowed"
                [maxSize]="question.maxSize" [resource]="question.resource" [formAction]="question.formAction"
                [formSubmit]="question.formSubmit" [value]="question.value" [crop_image]="question.crop_image"
                [compress_image]="question.compress_image" [delete_document]="question.delete_document"
                [multipleImageUpload]="question.multipleImageUpload" [capture_image]="question.capture_image"
                [icon_with_text]="question.icon_with_text" [question] = "question"
                (focus_out)="setManualChange(question,true);valueChange($event,question)">
            </dhs-file-uploader>
            <!-- <app-document-viewer *ngSwitchCase="'file_document'" [resourceName]="question.resource"></app-document-viewer> -->

            <!-- textbox-button -->
            <ng-container *ngSwitchCase="'textbox-button'">
                <dhs-input-button [formControlName]="question.key" [id]="question.key" [resource]="question.resource" [buttons]="question.button"
                 [buttonsConfig]="question.buttons_config"
                 [question]="question" [btnText]="question.btnText" [value]="question.value" (valueChange)="valueChange($event, question)">
                </dhs-input-button>
            </ng-container>

            <ng-container *ngSwitchCase="'inputSearch'">
                @if(question.visible)
                {
                <input-search [formControlName]="question.key"
                    [ngClass]="{ 'is-invalid': !isValid && f[question.key].errors }" tabIndex="-1"  (clearData)="setManualChange(question,true);valueChange($event,question)"
                    [placeholder]="question.hint" [showAdvSearch]="question.showAdvSearch" [clearSearch]="question.clearSearch" [data]="question.datasource"
                    (patientResult)="setManualChange(question,true);valueChange($event,question)"></input-search>
                }
            </ng-container>
            <ng-container *ngSwitchCase="'daterangepicker'">
                <div class="position-relative" tabindex="0">
                    <input tabindex="-1" type="text" [validations]="question.validations"
                        (click)="setPosition($event, question)" [question]="question" ngxDaterangepickerMd
                        [(ngModel)]="question.value" [formControlName]="question.key" [id]="question.key"
                        class="form-control input-element-main-search datepicker-search"
                        [placeholder]="'field.label.choose_date' | translate | async" showCancel="true"
                        [singleDatePicker]="question.singleDatePicker" [autoApply]="question.autoApply"
                        [showClearButton]="question.showClearButton" [timePicker]="question.timePicker"
                        [disableControl]="question.disabled" [locale]="question.locale"
                        [timePickerSeconds]="question.timePickerSeconds" [timePicker24Hour]="question.timePicker24Hour"
                        [minDateNumber]="question.minDateNumber" [forceEndOfDay]="question.forceEndOfDay"
                        [maxSpan]="question.maxSpan" [minDateUnit]="question.minDateUnit"
                        [maxDateNumber]="question.maxDateNumber" [maxDateUnit]="question.maxDateUnit"
                        [timePickerIncrement]="question.timePickerIncrement" [outPutFormat]="question.outPutFormat"
                        [showDropdowns]="question.showDropdowns" [minDate]="question.minDate"
                        [maxDate]="question.maxDate" [startKey]="question.startKey" [endKey]="question.endKey"
                        (keydown)="onKeydownDate($event, question)" [enableInput]="question.enableInput"
                        [alwaysShowCalendars]="!question.singleDatePicker && action == 'SEARCH' ? true: false"
                        [showCustomRangeLabel]="!question.singleDatePicker && action == 'SEARCH' ? true: false"
                        [ranges]="!question.singleDatePicker && action == 'SEARCH' ? ranges : []"
                        (change)="setManualChange(question,true);valueChange($event,question)"
                        [ngStyle]="!question.disabled?{'background-color': '#fff'}:{}" [drops]="question.position"
                        [attr.readonly]="utilService.isMobile()?'true':null" autocomplete="off" />
                    <a class="advsearchspan ngx-daterangepicker-action"
                        (click)="question.disabled?'':openDatepicker();setPosition($event, question);">
                        <img class="ngx-daterangepicker-action" src="assets/images/icon-calendar.svg" />
                    </a>
                </div>

            </ng-container>
            <ng-container *ngSwitchCase="'taginput'">
                @if(question.visible)
                {
                <app-tag-input [formControlName]="question.key" [placeholder]="question.hint"
                    [question]="question" [value]="question.value"
                    (focus_out)="setManualChange(question,true);valueChange($event,question)">
                </app-tag-input>
            }
            </ng-container>
            <ng-container *ngSwitchCase="'rating'">
                <dhs-rating [value]="question.value" [formControlName]="question.key" [id]="question.key"
                    [req_stars]="question.req_stars"
                    (valueChange)="setManualChange(question,true);valueChange($event,question)">
                </dhs-rating>
            </ng-container>
            <ng-container *ngSwitchCase="'score'">
                <dhs-score [formControlName]="question.key" [radio_support]="question.radio_support"
                    [isScoreData]="question.isScoreData" [totalScoreDisable]="question.totalScoreDisable"
                    [scoreField]="question.scoreField" [scoreData]="question.scoreData" [id]="question.key"
                    [value]="question.value" [question]="question">
                </dhs-score>
            </ng-container>
            <ng-container *ngSwitchCase="'annotation'">
                @if(question.visible)
                {
                <app-document-with-thumbnail [formControlName]="question.key" [datasource]="question.datasource" [question]="question" [value]="question.value"
                    (valueChange)="setManualChange(question,true);valueChange($event,question)">
                </app-document-with-thumbnail>
            }
            </ng-container>
            <ng-container *ngSwitchCase="'imageEditor'">
                @if(question.visible)
                {
                <app-image-editor [formControlName]="question.key" [datasource]="question.datasource" [question]="question" [value]="question.value"
                    (valueChange)="setManualChange(question,true);valueChange($event,question)" style="min-width: 100%;">
                </app-image-editor>
            }
            </ng-container>

            <ng-container *ngSwitchCase="'edit_grid'">
                <!--------------------------------------------------OLD EDITBALE GRID---------------------------------------------->
                <kx-editable-grid [formControlName]="question.key"
                    (checkBoxData)="setManualChange(question,true);valueChange($event,question)"
                    [resourceName]="question.resource" [emitDataOnSubmit]="question.emitDataOnSubmit"
                    [OutSourcedata]="question.value" [attr.required]="question.required"> </kx-editable-grid>
            </ng-container>
            <ng-container *ngSwitchCase="'editgrid'">
                <dhs-editable-grid [formFlag]=1 [parentForm]="form" [formControlName]="question.key"
                    [resource]="question.resource" [class]="question.resource"
                    (listen_changes)="valueChange($event.object.value,question)" [config]="question.config"
                    style="min-width: 100%;"></dhs-editable-grid>
            </ng-container>
            <ng-container *ngSwitchCase="'timepicker'">
                <dhs-timepicker [formControlName]="question.key" [timePickerSeconds]="question.timePickerSeconds"
                    [timePicker24Hour]="question.timePicker24Hour" [timePickerIncrement]="question.timePickerIncrement" [disabled]="question.disabled"
                    [value]="question.value" [validations]="question.validations"
                    [minDateNumber]="question.minDateNumber" [minDateUnit]="question.minDateUnit"
                    [maxDateNumber]="question.maxDateNumber" [maxDateUnit]="question.maxDateUnit"
                    (change)="setManualChange(question,true);valueChange($event,question)">
                </dhs-timepicker>
            </ng-container>
            <ng-container *ngSwitchCase="'editable-table'">
                <dhs-editable-table [formControlName]="question.key" [id]="question.key" [minWidth]="question.minWidth"
                    [resource]="question.resource" [datasource]="question.datasource" [value]="question.value"
                    [dependentField]="question.dependentField" [fieldDataSource]="question.fieldDataSource"
                    (valueAdded)="eventFired($event,question);" [parentForm]="form"> </dhs-editable-table>
            </ng-container>
            <ng-container *ngSwitchCase="'range'">
                <kx-range [formControlName]="question.key" [id]="question.key" [data]="question.value"
                    [fieldDataSource]="question.resource">
                </kx-range>
            </ng-container>
            <!------------------------------------Inclusion-exclusion--------------------------------------->
            <ng-container *ngSwitchCase="'inclusion-exclusion'">
                <app-inclusion-exclusion [formControlName]="question.key" [config]="{question:question,form:form}"
                    [value]="[]" [reload]="question.reload"></app-inclusion-exclusion>
            </ng-container>
            <!------------------------------ Month Year Picker--------------------------------------------------- -->
            <ng-container *ngSwitchCase="'flags'">
                @if(question.visible)
                {
                <app-flags [config]="{item:form.value,setting:{conditions:question.flag_condition}}">
                </app-flags>
            }
            </ng-container>
            <ng-container *ngSwitchCase="'dynamic-table'">
                <app-dynamic-table [formControlName]="question.key" [value]="question.value" [question]="question">
                </app-dynamic-table>
            </ng-container>
            <ng-container *ngSwitchCase="'monthYearPicker'">
                @if(question.visible)
                {
                <kx-month-picker [formControlName]="question.key"
                    [config]="{question:question,form:form}" [id]="question.key" [value]="question.value"
                    [resource]="question.resource" [placeholder]="question.placeholder" [disabled]="question.disabled"
                    (change)="setManualChange(question,false);valueChange($event,question,false)"
                    [disableNextYearMonth]="question.disableNextYearMonth"
                    [disablePreviousYearMonth]="question.disablePreviousYearMonth" [displayFormat]="question.format">
                </kx-month-picker>
            }
            </ng-container>
            <!----------------------tickets------------------------------->
            <ng-container *ngSwitchCase="'tickets'">
                <dhs-tickets [value]="question.value" [formControlName]="question.key" [id]="question.key"
                    (valueChange)="setManualChange(question,true);valueChange($event,question)"></dhs-tickets>
            </ng-container>
            <ul class="list-group macro-dropdown-menu" *ngIf="isShown">
                @if(macroText.macro_data && macroText.macro_data.length > 0)
                {                
                    <ng-container>
                        @for (data of macroText.macro_data; track data.macro_key) {
                    <li class="list-group-item"
                        [id]="question.macro_datasource.getterValue ? macroValue(data,question) : data.macro_description"
                        (click)="handler($event)" (keydown)="handler($event)" [triggered]="isShown"
                        (clickOutside)="displayMacro($event)">
                        <!-- {{question.macro_datasource.getterKey ? macroKey(data,question) : data.macro_key}} -->
                        {{data.macro_key}} | {{data.macro_description}}
                    </li>
                }
                </ng-container>
            }
                @if(macroText.macro_data && macroText.macro_data.length == 0)
                {
                <ng-container>
                    <li class="list-group-item" [triggered]="isShown" (clickOutside)="displayMacro($event)">No Record
                        Found</li>
                </ng-container>
            }
            </ul>
        </ng-container>
        <ng-template #popTemplate>
            @if(question.controlType!='fileuploader' && question.controlType!='checkbox' && question.controlType!='radio')
            {
            <span></span>
            }
            <span [innerHTML]="question.cstm_error_msg && question.cstm_error_msg != undefined ? '':(question.label | translate |
                async)"></span>
            {{errorMessage}}
        </ng-template>
        @if(question.controlType !== 'hidden' && !insideGrid && !isValid && f[question.key].errors)
        {
        <ng-container>
            @if(question.controlType !== 'checkbox' && question.controlType !== 'radio')
            {
            <span
                [ngClass]="question.controlType == 'editgrid' ? 'input-error-msg editgrid-error-msg': 'input-error-msg'">{{'field.label.Invalid_Input'
                | translate | async }}</span>
            }
            <div [ngClass]="{'input-detail-error editgrid-detail-error': question.controlType == 'editgrid' , 'input-detail-error':question.controlType != 'editgrid', 'input-detail-error-with-microphone':(preferenceService.checkCommonConfigEnabled('voice_search') && checkConditionforError(question.controlType))}"
                [popover]="popTemplate" triggers="mouseenter:mouseleave">
                <i class="fa fa-exclamation-triangle" aria-hidden="true"></i>
            </div>
        </ng-container>
    }
    </div>
</ng-container>